import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, Fragment as _Fragment, createElementBlock as _createElementBlock, withModifiers as _withModifiers, renderList as _renderList, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "d-flex align-center gap-1" }
const _hoisted_2 = { class: "text-h6 font-weight-bold mb-1" }
const _hoisted_3 = { class: "text-body-2 text-grey-darken-1" }
const _hoisted_4 = { class: "text-body-2 text-grey-darken-1" }
const _hoisted_5 = {
  key: 0,
  class: "mb-3",
  style: {"width":"200px"}
}
const _hoisted_6 = { class: "d-flex align-center gap-1 mb-1" }
const _hoisted_7 = {
  key: 1,
  class: "text-body-2 text-orange-darken-2 mb-3"
}
const _hoisted_8 = {
  key: 2,
  class: "text-body-2 text-orange-darken-2 mb-3"
}
const _hoisted_9 = {
  key: 0,
  class: "text-left"
}
const _hoisted_10 = {
  key: 1,
  class: "text-right"
}
const _hoisted_11 = {
  key: 2,
  class: "text-right"
}
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { class: "text-right" }
const _hoisted_14 = {
  key: 1,
  class: "text-right"
}
const _hoisted_15 = {
  key: 0,
  class: "text-grey-darken-1"
}
const _hoisted_16 = { key: 1 }
const _hoisted_17 = {
  key: 2,
  class: "text-right"
}
const _hoisted_18 = {
  key: 0,
  class: "text-grey-darken-1"
}
const _hoisted_19 = {
  key: 1,
  class: "text-grey-darken-1"
}
const _hoisted_20 = { key: 2 }
const _hoisted_21 = { class: "text-body-2 bg-grey-lighten-5" }
const _hoisted_22 = { class: "text-right" }
const _hoisted_23 = { class: "text-body-2 bg-grey-lighten-5" }
const _hoisted_24 = { colspan: "4" }
const _hoisted_25 = { class: "text-right" }
const _hoisted_26 = { class: "font-weight-bold bg-grey-lighten-4" }
const _hoisted_27 = { class: "text-right text-green-darken-2" }
const _hoisted_28 = {
  key: 1,
  class: "font-weight-bold bg-grey-lighten-4"
}
const _hoisted_29 = { class: "text-right" }
const _hoisted_30 = { class: "text-right text-green-darken-2" }
const _hoisted_31 = {
  key: 2,
  class: "font-weight-bold bg-grey-lighten-4"
}
const _hoisted_32 = ["colspan"]
const _hoisted_33 = { class: "text-right" }
const _hoisted_34 = {
  key: 0,
  class: "d-flex justify-center mt-2"
}
const _hoisted_35 = {
  key: 4,
  class: "py-4 text-body-2 text-grey text-center"
}
const _hoisted_36 = {
  key: 5,
  class: "mt-2 mb-2"
}
const _hoisted_37 = {
  class: "d-flex align-center justify-space-between pa-3 rounded mb-1",
  style: {"background":"#f0fdf4","border":"1px solid #86efac"}
}
const _hoisted_38 = { class: "d-flex align-center gap-2" }
const _hoisted_39 = { class: "text-caption text-grey-darken-1" }
const _hoisted_40 = { class: "text-body-2 font-weight-bold text-green-darken-2" }
const _hoisted_41 = {
  key: 6,
  class: "mb-4"
}
const _hoisted_42 = { class: "d-flex align-center justify-space-between mb-1" }
const _hoisted_43 = { class: "d-flex align-center gap-1 text-body-1 font-weight-medium" }
const _hoisted_44 = { class: "text-body-1 font-weight-bold text-green-darken-2" }
const _hoisted_45 = { class: "text-caption text-grey-darken-1" }
const _hoisted_46 = { class: "mt-4 mb-2 text-body-2" }
const _hoisted_47 = { class: "text-body-2 text-grey-darken-1 mb-4" }
const _hoisted_48 = { class: "expense-list-card mb-4" }
const _hoisted_49 = { class: "expense-list-head d-flex align-center justify-space-between pa-3" }
const _hoisted_50 = { class: "text-body-1 font-weight-bold" }
const _hoisted_51 = { class: "text-body-2 font-weight-regular text-grey-darken-1 ml-1" }
const _hoisted_52 = {
  key: 0,
  class: "text-body-2 font-weight-regular text-grey-darken-1 ml-2"
}
const _hoisted_53 = {
  key: 0,
  class: "py-4 text-body-2 text-grey text-center"
}
const _hoisted_54 = {
  key: 0,
  class: "text-uppercase text-caption"
}
const _hoisted_55 = {
  key: 1,
  class: "text-uppercase text-caption"
}
const _hoisted_56 = {
  key: 2,
  class: "text-uppercase text-caption text-right"
}
const _hoisted_57 = ["title", "onClick"]
const _hoisted_58 = { style: {"width":"28px","padding-left":"10px","padding-right":"0"} }
const _hoisted_59 = { class: "text-body-2" }
const _hoisted_60 = { class: "text-body-2" }
const _hoisted_61 = {
  key: 0,
  class: "text-body-2 text-grey-darken-1"
}
const _hoisted_62 = { key: 1 }
const _hoisted_63 = { class: "text-body-2 text-right" }
const _hoisted_64 = {
  key: 2,
  class: "text-body-2 text-right"
}
const _hoisted_65 = {
  key: 0,
  class: "text-grey-darken-1"
}
const _hoisted_66 = {
  key: 1,
  class: "text-grey-darken-1"
}
const _hoisted_67 = { key: 2 }
const _hoisted_68 = {
  class: "d-flex align-center justify-space-between px-3 py-2 text-body-2 text-grey-darken-1",
  style: {"border-top":"1px solid #e8eaed"}
}
const _hoisted_69 = {
  key: 0,
  class: "d-flex align-center gap-1"
}
const _hoisted_70 = { class: "expense-page-indicator" }
const _hoisted_71 = { class: "expense-list-foot" }
const _hoisted_72 = { class: "expense-totals-row" }
const _hoisted_73 = { class: "text-body-2" }
const _hoisted_74 = { class: "expense-totals-row" }
const _hoisted_75 = { class: "text-body-2" }
const _hoisted_76 = { class: "expense-totals-row" }
const _hoisted_77 = { class: "text-body-2" }
const _hoisted_78 = { class: "text-body-2" }
const _hoisted_79 = { class: "expense-totals-row expense-totals-row--total" }
const _hoisted_80 = { class: "text-body-1 font-weight-bold text-green-darken-2" }
const _hoisted_81 = { class: "mt-2 mb-3 text-body-2" }
const _hoisted_82 = {
  key: 0,
  class: "interest-section mb-4"
}
const _hoisted_83 = { class: "text-body-2 font-weight-bold" }
const _hoisted_84 = {
  key: 0,
  class: "ml-1"
}
const _hoisted_85 = { class: "pl-2" }
const _hoisted_86 = {
  key: 0,
  class: "text-body-2 text-grey-darken-1 mb-2 d-flex align-center gap-1"
}
const _hoisted_87 = {
  key: 1,
  class: "text-body-2 text-orange-darken-2 mb-2"
}
const _hoisted_88 = {
  key: 2,
  class: "text-body-2 text-orange-darken-2 mb-2"
}
const _hoisted_89 = {
  key: 3,
  class: "mt-2 mb-2"
}
const _hoisted_90 = {
  class: "d-flex align-center justify-space-between pa-3 rounded mb-1",
  style: {"background":"#f0fdf4","border":"1px solid #86efac"}
}
const _hoisted_91 = { class: "d-flex align-center gap-2" }
const _hoisted_92 = { class: "text-caption text-grey-darken-1" }
const _hoisted_93 = { class: "text-body-2 font-weight-bold text-green-darken-2" }
const _hoisted_94 = {
  key: 4,
  class: "mb-3"
}
const _hoisted_95 = { class: "d-flex align-center justify-space-between mb-1" }
const _hoisted_96 = { class: "d-flex align-center gap-1 text-body-1 font-weight-medium" }
const _hoisted_97 = { class: "text-body-1 font-weight-bold text-green-darken-2" }
const _hoisted_98 = { class: "text-caption text-grey-darken-1" }
const _hoisted_99 = {
  key: 1,
  class: "co-counsel-section mb-4"
}
const _hoisted_100 = { class: "px-3 pb-2" }
const _hoisted_101 = {
  key: 0,
  class: "d-flex justify-end"
}
const _hoisted_102 = {
  key: 1,
  class: "co-counsel-panel rounded-lg pa-3 bg-[#f1faf4] border border-[#bfe0c6]"
}
const _hoisted_103 = { class: "d-flex align-center justify-space-between mb-2" }
const _hoisted_104 = ["data-vendor-id"]
const _hoisted_105 = { class: "text-body-2 font-weight-bold text-green-darken-4 d-block" }
const _hoisted_106 = { class: "text-caption text-grey d-block" }
const _hoisted_107 = { class: "d-flex align-center gap-2" }
const _hoisted_108 = {
  key: 0,
  class: "text-body-2"
}
const _hoisted_109 = { class: "w-[110px]" }
const _hoisted_110 = {
  key: 1,
  class: "text-body-2 text-grey-darken-1 d-block text-right"
}
const _hoisted_111 = { class: "d-flex align-center justify-space-between pt-2 mt-1 border-t border-[#bfe0c6]" }
const _hoisted_112 = { class: "text-body-2 font-weight-bold text-green-darken-4" }
const _hoisted_113 = { class: "d-flex align-center justify-space-between px-3 pb-3" }
const _hoisted_114 = { class: "text-body-1 font-weight-bold text-green-darken-2" }
const _hoisted_115 = { class: "text-body-2" }
const _hoisted_116 = { class: "sett-step-footer" }

import {
  ref, computed, onMounted, watch,
} from 'vue';
import { format } from 'date-fns';
import LlSecondaryButton from '@/components/LlSecondaryButton.vue';
import AlertBar from '@/components/AlertBar.vue';
import LlTooltip from '@/components/LlTooltip.vue';
import QboIcon from '@/components/QboIcon.vue';
import LlWarningBanner from '@/components/LlWarningBanner.vue';
import LlTextField from '@/components/LlTextField.vue';
import LlIcon from '@/components/LlIcon.vue';
import { formatCurrency, formatLongDateString, parseLocalDate, yyyymmdddash } from '@/services/utils';
import LlDatePicker from '@/components/LlDatePicker.vue';
import { daysBetween, computeExpenseInterest } from '@/utils/expenseInterest';
import { useExportUtilities } from '@/composables/useExportUtilities';
import type { FeeMethod, ExpenseArrangement, MatterExpenseItem, CoCounselExpense } from '@/models/settlementTypes';
import { roleLabel } from '@/utils/roleLabels';
import { FEE_METHOD, EXPENSE_ARRANGEMENT } from '@/constants/settlementConstants';

// pageSize.value is computed so the redesign (6/page) and old design (15/page) can coexist


export default /*@__PURE__*/_defineComponent({
  __name: 'SettlementExpenseStep',
  props: {
  expenses: { type: Array as () => MatterExpenseItem[], default: (): MatterExpenseItem[] => [] },
  totalExpenses: { type: Number, default: 0 },
  /** ClientPays only: previously billed case costs, outside this unbilled batch (sc-46645).
   *  0 for every other arrangement. */
  billedExpensesTotal: { type: Number, default: 0 },
  /** ClientPays only: the itemized previously-billed expenses backing billedExpensesTotal —
   *  merged into the table below with a Status column so users can see exactly what's billed
   *  vs unbilled, not just the two totals. Empty for every other arrangement. */
  billedExpenses: { type: Array as () => MatterExpenseItem[], default: (): MatterExpenseItem[] => [] },
  expenseArrangement: { type: String as () => ExpenseArrangement, default: EXPENSE_ARRANGEMENT.FIRM },
  feeMethod: { type: String as () => FeeMethod, default: FEE_METHOD.GROSS },
  hasNegativeFeeBase: { type: Boolean, default: false },
  saving: { type: Boolean, default: false },
  loading: { type: Boolean, default: false },
  companyExpenseInterestRate: { type: Number as () => number | null, default: null },
  noExpenseInterest: { type: Boolean, default: false },
  expenseFromDate: { type: String as () => string | null, default: null },
  totalInterest: { type: Number, default: 0 },
  interestConfirmed: { type: Boolean, default: false },
  confirmedExpenseFromDate: { type: String as () => string | null, default: null },
  confirmedTotalInterest: { type: Number, default: 0 },
  /** Feature flipper — when true shows "+ Add Expense" button and per-row edit icons.
   *  When false, the old "Edit on Expenses page" link is shown instead. */
  expenseInlineEnabled: { type: Boolean, default: false },
  /** Gate all SC-45761/SC-45762 redesign UI behind this flag.
   *  false = old design (tfoot totals, 15/page, Days col, amount in button).
   *  true  = new design (external totals, 6/page, green dot, no Days). */
  redesignEnabled: { type: Boolean, default: false },
  /** Law firm name — shown in the new-design card header as "{firmName}'s expenses:". */
  firmName: { type: String, default: '' },
  /** Mirror of me.features.importcsv — when true show the Vendor column in the redesign table. */
  showVendor: { type: Boolean, default: false },
  /** Mirror of features.coCounsel — gates the whole Co-Counsel Expenses sub-section. */
  coCounselEnabled: { type: Boolean, default: false },
  /** One row per matter recipient (co-counsel or referring attorney), joined with any
   *  confirmed Step 2 amount. Empty until the parent loads it via load-co-counsel-expenses. */
  coCounselExpenses: { type: Array as () => CoCounselExpense[], default: (): CoCounselExpense[] => [] },
},
  emits: [
  'confirm-expenses',
  'confirm-interest',
  'go-back',
  'open-add-expense',
  'open-edit-expense',
  'remove-interest',
  /** Fallback: navigate to the standalone Expenses page (flag off). */
  'view-expenses',
  /** Old design only: user changed the interest as-of date inline on Step 2. */
  'update:expenseFromDate',
  /** New design only: user clicked a sortable column header — parent should reload from the
   *  backend with this orderby/order rather than the table re-sorting locally. */
  'update:sort',
  /** Ask the parent to fetch co-counsel expenses (mirrors Step 3's load-fee-recipients). */
  'load-co-counsel-expenses',
  /** User changed a coCounsel row's amount. referringAttorney rows never emit this — they have no input. */
  'update:coCounselExpense',
],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

/** Expense list toggle — collapsed by default */
const expenseListOpen = ref(false);

// ── Co-Counsel Expenses (P5.2) ─────────────────────────────
const coCounselSectionOpen = ref(false);

/** Auto-expand once if any row already has a confirmed/entered amount — otherwise a
 *  user returning to Step 2 sees the collapsed "Need to add..." link hiding data they
 *  already saved. Runs once (immediate covers data already in the store; the watcher
 *  covers it arriving async via load-co-counsel-expenses) and never fights a user who
 *  deliberately hits "Hide" afterward. */
let coCounselSectionAutoOpened = false;
watch(
  () => props.coCounselExpenses,
  (rows) => {
    if (!coCounselSectionAutoOpened && rows.some((e) => e.amount > 0)) {
      coCounselSectionOpen.value = true;
      coCounselSectionAutoOpened = true;
    }
  },
  { immediate: true },
);

/** Visible only when the flag is on and there's at least one matter recipient —
 *  the co-counsel endpoint already returns one row per recipient (joined with any
 *  confirmed amount), so this list's length doubles as the recipient-count check. */
const showCoCounselSection = computed(
  () => props.coCounselEnabled && props.coCounselExpenses.length > 0,
);

/** Reuses the existing expenseArrangement prop's friendly 'Absorbed' value — the
 *  FE-mapped form of the backend's FirmAbsorbs arrangement (see types.ts). */
const isFirmAbsorbsArrangement = computed(() => props.expenseArrangement === EXPENSE_ARRANGEMENT.ABSORBED);

/** FE-mapped form of the backend's ClientPays arrangement (see types.ts). */
const isClientPaysArrangement = computed(() => props.expenseArrangement === 'Client');

/** Total Case Costs = this batch's unbilled expenses + previously billed ones (sc-46645) —
 *  the same figure ConfirmExpensesAsync folds in and saves for ClientPays. Equals
 *  totalExpenses for every other arrangement, where billedExpensesTotal is always 0.
 *  Sum in integer cents to avoid float drift (both operands are already cent-rounded upstream). */
const totalCaseCosts = computed(() =>
  (Math.round(props.totalExpenses * 100) + Math.round(props.billedExpensesTotal * 100)) / 100);

const coCounselExpenseTotal = computed(() =>
  props.coCounselExpenses
    .filter((e) => e.role === 'coCounsel')
    .reduce((sum, e) => sum + (e.amount || 0), 0),
);

/** Bottom-line "Total Expenses" footer figure — the firm's own expenses plus
 *  whatever co-counsel expenses have been entered (0 when the section isn't
 *  shown or has no rows yet). The card-header total stays firm-only since its
 *  "(N)" count matches only the itemized table rows. */
const totalExpensesWithCoCounsel = computed(() => props.totalExpenses + coCounselExpenseTotal.value);

function onCoCounselAmountChange(vendorId: string, value: string | number) {
  const parsed = typeof value === 'number' ? value : parseFloat(value);
  emit('update:coCounselExpense', { vendorId, amount: Number.isFinite(parsed) ? parsed : 0 });
}

onMounted(() => {
  if (props.redesignEnabled && props.coCounselEnabled && props.coCounselExpenses.length === 0) {
    emit('load-co-counsel-expenses');
  }
});

/** Sort state for new-design table columns (Date, Description, Amount). Defaults to Date ascending. */
const sortKey = ref<'date' | 'description' | 'amount' | null>('date');
const sortDir = ref<'asc' | 'desc'>('asc');

function toggleSort(key: 'date' | 'description' | 'amount') {
  if (sortKey.value === key) {
    sortDir.value = sortDir.value === 'asc' ? 'desc' : 'asc';
  } else {
    sortKey.value = key;
    sortDir.value = 'asc';
  }
  currentPage.value = 1;
  // Order is now backend-driven — ask the parent to reload rather than re-sorting locally.
  emit('update:sort', { orderby: key, order: sortDir.value });
}

/** True when the interest input has changed since the last confirmation — re-confirm needed. */
const interestNeedsReconfirm = computed(
  () =>
    !props.interestConfirmed ||
    props.expenseFromDate !== props.confirmedExpenseFromDate ||
    props.totalInterest !== props.confirmedTotalInterest,
);

/** Interest section toggle — open by default until expenses/interest are confirmed, then collapsed. */
const interestOpen = ref(interestNeedsReconfirm.value);

/** Date model for the old-design inline date picker. */
const expenseFromDateModel = computed<Date | null>(() => parseLocalDate(props.expenseFromDate));

function onExpenseFromDateChange(val: Date | null) {
  const next = yyyymmdddash(val) || null;
  if (next === props.expenseFromDate) return;
  emit('update:expenseFromDate', next);
}

/** Show the interest column + date picker when: rate set, matter hasn't opted out, and firm advances all expenses (BR-V2-33) */
const showInterest = computed(
  () =>
    (props.companyExpenseInterestRate ?? 0) > 0 &&
    !props.noExpenseInterest &&
    props.expenseArrangement === EXPENSE_ARRANGEMENT.FIRM,
);


const hasConfirmedActiveInterest = computed(
  () =>
    showInterest.value &&
    props.interestConfirmed &&
    props.confirmedTotalInterest > 0 &&
    !interestNeedsReconfirm.value,
);

/** Page size: 6 rows in redesign, 15 in old design */
const pageSize = computed(() => (props.redesignEnabled ? 6 : 15));

/** Confirm button label — old design only. Shows Total Case Costs (unbilled + previously
 *  billed) so it matches what actually gets saved — equals totalExpenses for every
 *  non-ClientPays arrangement, where billedExpensesTotal is always 0 (sc-46645). */
const confirmButtonLabel = computed(() => {
  if (showInterest.value && props.totalInterest > 0) {
    return `${formatCurrency(totalCaseCosts.value)} + ${formatCurrency(props.totalInterest)} interest`;
  }
  return formatCurrency(totalCaseCosts.value);
});

/** "MM/dd/yyyy" display for use in the tfoot "through {date}" label */
const expenseFromDateDisplay = computed(() => {
  const d = parseLocalDate(props.expenseFromDate);
  return d ? format(d, 'MM/dd/yyyy') : '';
});

const currentPage = ref(1);

// Exclude the interest soft-cost from the table — it is shown below the table as a card.
// ClientPays only: merge in previously-billed case costs (tagged billed: true) so the Status
// column can show the whole picture in one table, not just two disconnected totals — billed
// rows are appended after unbilled, not date-interleaved (sc-46645).
const tableExpenses = computed(() => {
  const unbilled = props.expenses
    .filter((e) => !e.isExpenseInterest)
    .map((e) => ({ ...e, billed: false }));
  if (!isClientPaysArrangement.value || props.billedExpenses.length === 0) return unbilled;
  const billed = props.billedExpenses
    .filter((e) => !e.isExpenseInterest)
    .map((e) => ({ ...e, billed: true }));
  return [...unbilled, ...billed];
});

const totalPages = computed(() => Math.ceil(tableExpenses.value.length / pageSize.value));

// Clamp the page used for slicing so a shrinking list (e.g. after edits) doesn't leave
// currentPage past the end and render an empty page.
const effectivePage = computed(() => Math.min(currentPage.value, totalPages.value || 1));

const paginatedExpenses = computed(() => {
  const start = (effectivePage.value - 1) * pageSize.value;
  // tableExpenses is already in backend-sorted order (see update:sort) — just paginate it.
  return tableExpenses.value.slice(start, start + pageSize.value);
});

/** "Showing X–Y of Z" display values */
const paginationStart = computed(() => (effectivePage.value - 1) * pageSize.value + 1);
const paginationEnd = computed(() =>
  Math.min(effectivePage.value * pageSize.value, tableExpenses.value.length),
);

const noDateCount = computed(() =>
  tableExpenses.value.filter((e) => !e.date).length,
);

// Expenses dated strictly after the as-of date accrue 0 days of interest.
const afterAsOfCount = computed(() => {
  if (!props.expenseFromDate) return 0;
  return tableExpenses.value.filter(
    (e) => e.date && daysBetween(props.expenseFromDate as string, e.date) > 0,
  ).length;
});

function daysForExpense(expense: MatterExpenseItem): number {
  if (!props.expenseFromDate || !expense.date) return 0;
  return daysBetween(expense.date, props.expenseFromDate);
}

function interestForExpense(expense: MatterExpenseItem): number {
  if (!props.expenseFromDate || !expense.date || !props.companyExpenseInterestRate) return 0;
  const days = daysForExpense(expense);
  return computeExpenseInterest(expense.amount, props.companyExpenseInterestRate, days);
}

const { exportCSV, formatDate } = useExportUtilities();

/** Export the currently-loaded (backend-sorted) expense list — mirrors exactly what's shown in
 *  the table, not just the current page. Columns match the table's visible columns only. */
function exportExpensesCsv() {
  const columnMap: Record<string, string | ((expense: MatterExpenseItem & { billed?: boolean }) => unknown)> = {
    Date: (expense) => formatDate(expense.date),
    Description: 'description',
    ...(props.showVendor
      ? {
        Vendor: (expense) =>
          expense.vendor?.displayName || expense.vendor?.name || '',
      }
      : {}),
    ...(isClientPaysArrangement.value
      ? { Status: (expense) => (expense.billed ? 'Billed' : 'Unbilled') }
      : {}),
    Amount: (expense) => formatCurrency(expense.amount),
    ...(showInterest.value
      ? {
        Interest: (expense) =>
          expense.date && props.expenseFromDate ? formatCurrency(interestForExpense(expense)) : '',
      }
      : {}),
  };
  exportCSV(tableExpenses.value, columnMap, {
    filename: `settlement-expenses-${yyyymmdddash(new Date())}`,
  });
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_skeleton_loader = _resolveComponent("v-skeleton-loader")!
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_table = _resolveComponent("v-table")!
  const _component_v_pagination = _resolveComponent("v-pagination")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, {
    flat: "",
    class: "border-0 !bg-[rgb(var(--v-theme-surface))]"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card_title, { class: "d-flex align-center justify-space-between py-3 px-4" }, {
        default: _withCtx(() => [
          _createElementVNode("span", _hoisted_1, [
            _cache[21] || (_cache[21] = _createTextVNode(" Step 2: Confirm Expenses ", -1)),
            (__props.redesignEnabled)
              ? (_openBlock(), _createBlock(LlTooltip, {
                  key: 0,
                  "max-width": "260",
                  text: "Interest accrues on hard costs only, shown separately when an interest rate is set. Edit expenses on the Expenses page, then return to re-confirm."
                }, {
                  activator: _withCtx(() => [
                    _createVNode(_component_v_icon, {
                      size: "16",
                      color: "grey",
                      class: "cursor-pointer mb-1"
                    }, {
                      default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                        _createTextVNode("mdi-information-outline", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          (__props.expenseInlineEnabled)
            ? (_openBlock(), _createBlock(LlSecondaryButton, {
                key: 0,
                size: "small",
                color: "primary",
                "prepend-icon": "mdi-plus",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('open-add-expense')))
              }, {
                default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                  _createTextVNode(" Add Expense ", -1)
                ]))]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_component_v_card_text, null, {
        default: _withCtx(() => [
          (__props.loading)
            ? (_openBlock(), _createBlock(_component_v_skeleton_loader, {
                key: 0,
                type: "table-row-divider@5"
              }))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                (!__props.redesignEnabled)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createVNode(_component_v_sheet, {
                        rounded: "lg",
                        class: "pa-4 mb-4",
                        color: "green-lighten-5",
                        border: ""
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_2, _toDisplayString(isClientPaysArrangement.value ? 'Total Case Costs' : 'Total Expenses') + ": " + _toDisplayString(_unref(formatCurrency)(isClientPaysArrangement.value ? totalCaseCosts.value : __props.totalExpenses)), 1),
                          (isClientPaysArrangement.value && __props.billedExpensesTotal > 0)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createElementVNode("div", _hoisted_3, " Unbilled (confirming now): " + _toDisplayString(_unref(formatCurrency)(__props.totalExpenses)), 1),
                                _createElementVNode("div", _hoisted_4, " Previously billed: " + _toDisplayString(_unref(formatCurrency)(__props.billedExpensesTotal)), 1)
                              ], 64))
                            : _createCommentVNode("", true),
                          _createElementVNode("a", {
                            class: "text-primary text-body-2 cursor-pointer",
                            href: "#",
                            onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.$emit('view-expenses')), ["prevent"]))
                          }, " View or edit expenses for this matter → ")
                        ]),
                        _: 1
                      }),
                      (showInterest.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                            _createElementVNode("div", _hoisted_6, [
                              _cache[24] || (_cache[24] = _createElementVNode("span", { class: "text-body-2 font-weight-bold" }, "Interest As-Of Date", -1)),
                              _createVNode(LlTooltip, { text: "The end date for interest accrual. Expenses dated after this date accrue 0 days of interest." }, {
                                activator: _withCtx(() => [
                                  _createVNode(_component_v_icon, {
                                    size: "14",
                                    color: "grey",
                                    class: "cursor-pointer"
                                  }, {
                                    default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
                                      _createTextVNode("mdi-information-outline", -1)
                                    ]))]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _createVNode(LlDatePicker, {
                              "model-value": expenseFromDateModel.value,
                              "show-button": false,
                              "hide-details": true,
                              label: "",
                              "onUpdate:modelValue": onExpenseFromDateChange
                            }, null, 8, ["model-value"])
                          ]))
                        : _createCommentVNode("", true),
                      (showInterest.value && noDateCount.value > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(noDateCount.value) + " expense" + _toDisplayString(noDateCount.value > 1 ? 's' : '') + " excluded from interest calculation (no date) ", 1))
                        : _createCommentVNode("", true),
                      (showInterest.value && afterAsOfCount.value > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(afterAsOfCount.value) + " expense" + _toDisplayString(afterAsOfCount.value > 1 ? 's' : '') + " dated after the as-of date accrue 0 interest ", 1))
                        : _createCommentVNode("", true),
                      (tableExpenses.value.length > 0)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                            _createVNode(_component_v_table, {
                              density: "compact",
                              class: "mb-2"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("thead", null, [
                                  _createElementVNode("tr", null, [
                                    _cache[25] || (_cache[25] = _createElementVNode("th", { class: "text-left" }, "Description", -1)),
                                    _cache[26] || (_cache[26] = _createElementVNode("th", { class: "text-left" }, "Date", -1)),
                                    (isClientPaysArrangement.value)
                                      ? (_openBlock(), _createElementBlock("th", _hoisted_9, "Status"))
                                      : _createCommentVNode("", true),
                                    _cache[27] || (_cache[27] = _createElementVNode("th", { class: "text-right" }, "Amount", -1)),
                                    (showInterest.value)
                                      ? (_openBlock(), _createElementBlock("th", _hoisted_10, "Days"))
                                      : _createCommentVNode("", true),
                                    (showInterest.value)
                                      ? (_openBlock(), _createElementBlock("th", _hoisted_11, "Interest"))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                _createElementVNode("tbody", null, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paginatedExpenses.value, (expense) => {
                                    return (_openBlock(), _createElementBlock("tr", {
                                      key: expense.id
                                    }, [
                                      _createElementVNode("td", null, _toDisplayString(expense.description || '—'), 1),
                                      _createElementVNode("td", null, _toDisplayString(expense.date ? _unref(formatLongDateString)(expense.date) : '—'), 1),
                                      (isClientPaysArrangement.value)
                                        ? (_openBlock(), _createElementBlock("td", _hoisted_12, [
                                            _createVNode(_component_v_chip, {
                                              size: "x-small",
                                              color: expense.billed ? 'grey' : 'success',
                                              variant: "tonal"
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(expense.billed ? 'Billed' : 'Unbilled'), 1)
                                              ]),
                                              _: 2
                                            }, 1032, ["color"])
                                          ]))
                                        : _createCommentVNode("", true),
                                      _createElementVNode("td", _hoisted_13, _toDisplayString(_unref(formatCurrency)(expense.amount)), 1),
                                      (showInterest.value)
                                        ? (_openBlock(), _createElementBlock("td", _hoisted_14, [
                                            (!expense.date || !__props.expenseFromDate)
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_15, "—"))
                                              : (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(daysForExpense(expense)), 1))
                                          ]))
                                        : _createCommentVNode("", true),
                                      (showInterest.value)
                                        ? (_openBlock(), _createElementBlock("td", _hoisted_17, [
                                            (!expense.date)
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_18, "N/A"))
                                              : (!__props.expenseFromDate)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_19, "—"))
                                                : (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(_unref(formatCurrency)(interestForExpense(expense))), 1))
                                          ]))
                                        : _createCommentVNode("", true)
                                    ]))
                                  }), 128))
                                ]),
                                _createElementVNode("tfoot", null, [
                                  (showInterest.value && __props.interestConfirmed && !interestNeedsReconfirm.value)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _createElementVNode("tr", _hoisted_21, [
                                          _cache[28] || (_cache[28] = _createElementVNode("td", { colspan: "4" }, "Total Expenses", -1)),
                                          _createElementVNode("td", _hoisted_22, _toDisplayString(_unref(formatCurrency)(__props.totalExpenses)), 1)
                                        ]),
                                        _createElementVNode("tr", _hoisted_23, [
                                          _createElementVNode("td", _hoisted_24, " Total Expense Interest (" + _toDisplayString(__props.companyExpenseInterestRate) + "%" + _toDisplayString(__props.expenseFromDate ? ` through ${expenseFromDateDisplay.value}` : '') + ") ", 1),
                                          _createElementVNode("td", _hoisted_25, _toDisplayString(_unref(formatCurrency)(__props.totalInterest)), 1)
                                        ]),
                                        _createElementVNode("tr", _hoisted_26, [
                                          _cache[29] || (_cache[29] = _createElementVNode("td", { colspan: "4" }, "Total with Interest", -1)),
                                          _createElementVNode("td", _hoisted_27, _toDisplayString(_unref(formatCurrency)(__props.totalExpenses + __props.totalInterest)), 1)
                                        ])
                                      ], 64))
                                    : (showInterest.value)
                                      ? (_openBlock(), _createElementBlock("tr", _hoisted_28, [
                                          _cache[30] || (_cache[30] = _createElementVNode("td", { colspan: "2" }, "Total", -1)),
                                          _createElementVNode("td", _hoisted_29, _toDisplayString(_unref(formatCurrency)(__props.totalExpenses)), 1),
                                          _cache[31] || (_cache[31] = _createElementVNode("td", null, null, -1)),
                                          _createElementVNode("td", _hoisted_30, _toDisplayString(__props.expenseFromDate ? _unref(formatCurrency)(__props.totalInterest) : '—'), 1)
                                        ]))
                                      : (_openBlock(), _createElementBlock("tr", _hoisted_31, [
                                          _createElementVNode("td", {
                                            colspan: isClientPaysArrangement.value ? 3 : 2
                                          }, _toDisplayString(isClientPaysArrangement.value ? 'Total Case Costs' : 'Total'), 9, _hoisted_32),
                                          _createElementVNode("td", _hoisted_33, _toDisplayString(_unref(formatCurrency)(isClientPaysArrangement.value ? totalCaseCosts.value : __props.totalExpenses)), 1)
                                        ]))
                                ])
                              ]),
                              _: 1
                            }),
                            (totalPages.value > 1)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                                  _createVNode(_component_v_pagination, {
                                    modelValue: currentPage.value,
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((currentPage).value = $event)),
                                    length: totalPages.value,
                                    "total-visible": 7,
                                    density: "compact"
                                  }, null, 8, ["modelValue", "length"])
                                ]))
                              : _createCommentVNode("", true)
                          ], 64))
                        : (_openBlock(), _createElementBlock("div", _hoisted_35, _toDisplayString(isClientPaysArrangement.value ? 'No expenses for this matter.' : 'No unbilled expenses for this matter.'), 1)),
                      (hasConfirmedActiveInterest.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                            _createElementVNode("div", _hoisted_37, [
                              _createElementVNode("div", _hoisted_38, [
                                _createVNode(LlIcon, {
                                  icon: "mdi-check-circle",
                                  color: "success",
                                  size: "18"
                                }),
                                _createElementVNode("div", null, [
                                  _cache[32] || (_cache[32] = _createElementVNode("div", { class: "text-body-2 font-weight-bold text-green-darken-2" }, " Interest Confirmed — Expense Created ", -1)),
                                  _createElementVNode("div", _hoisted_39, _toDisplayString(__props.companyExpenseInterestRate) + "% interest charged on advanced client costs ", 1)
                                ])
                              ]),
                              _createElementVNode("span", _hoisted_40, _toDisplayString(_unref(formatCurrency)(__props.confirmedTotalInterest)), 1)
                            ]),
                            _createElementVNode("a", {
                              class: "text-body-2 text-error cursor-pointer",
                              href: "#",
                              onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.$emit('remove-interest')), ["prevent"]))
                            }, " Remove interest expense ")
                          ]))
                        : _createCommentVNode("", true),
                      (showInterest.value && interestNeedsReconfirm.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                            _createElementVNode("div", _hoisted_42, [
                              _createElementVNode("span", _hoisted_43, [
                                _createTextVNode(" Total Expense Interest (" + _toDisplayString(__props.companyExpenseInterestRate) + "%): ", 1),
                                _createVNode(LlTooltip, { text: "Ensure your fee agreement authorizes interest on advanced expenses before including this line item." }, {
                                  activator: _withCtx(() => [
                                    _createVNode(_component_v_icon, {
                                      size: "14",
                                      color: "grey",
                                      class: "cursor-pointer"
                                    }, {
                                      default: _withCtx(() => [...(_cache[33] || (_cache[33] = [
                                        _createTextVNode("mdi-information-outline", -1)
                                      ]))]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _createElementVNode("span", _hoisted_44, _toDisplayString(_unref(formatCurrency)(__props.totalInterest)), 1)
                            ]),
                            _createVNode(LlSecondaryButton, {
                              color: "primary",
                              disabled: !__props.expenseFromDate || __props.totalInterest <= 0 || __props.saving,
                              loading: __props.saving,
                              class: "mb-1",
                              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('confirm-interest')))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(__props.interestConfirmed ? `Interest Confirmed (${_unref(formatCurrency)(__props.totalInterest)})` : `Confirm Interest (${_unref(formatCurrency)(__props.totalInterest)})`), 1)
                              ]),
                              _: 1
                            }, 8, ["disabled", "loading"]),
                            _createElementVNode("div", _hoisted_45, " Confirming creates an expense: \"" + _toDisplayString(__props.companyExpenseInterestRate) + "% interest charged on advanced client costs\" ", 1)
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_46, [
                        (__props.expenseArrangement === _unref(EXPENSE_ARRANGEMENT).ABSORBED)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              (__props.feeMethod === _unref(FEE_METHOD).NET)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _cache[34] || (_cache[34] = _createElementVNode("strong", null, "Firm absorbs expenses (net):", -1)),
                                    _createTextVNode(" These costs (" + _toDisplayString(_unref(formatCurrency)(__props.totalExpenses)) + ") will reduce the fee base — the attorney fee is calculated on the settlement minus expenses. The client pays no expenses. ", 1)
                                  ], 64))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _cache[35] || (_cache[35] = _createElementVNode("strong", null, "Firm absorbs expenses (gross):", -1)),
                                    _createTextVNode(" These costs (" + _toDisplayString(_unref(formatCurrency)(__props.totalExpenses)) + ") will be deducted from the gross attorney fee. The client pays no expenses. ", 1)
                                  ], 64))
                            ], 64))
                          : (__props.expenseArrangement === _unref(EXPENSE_ARRANGEMENT).CLIENT)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                (__props.feeMethod === _unref(FEE_METHOD).NET)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      _cache[36] || (_cache[36] = _createElementVNode("strong", null, "Net method:", -1)),
                                      _createTextVNode(" All case costs (" + _toDisplayString(_unref(formatCurrency)(totalCaseCosts.value)) + ") are deducted from the recovery ", 1),
                                      _cache[37] || (_cache[37] = _createElementVNode("em", null, "before", -1)),
                                      _cache[38] || (_cache[38] = _createTextVNode(" calculating the fee. ", -1))
                                    ], 64))
                                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                      _cache[39] || (_cache[39] = _createElementVNode("strong", null, "Gross method:", -1)),
                                      _createTextVNode(" The attorney fee is calculated on the full recovery amount. Case costs (" + _toDisplayString(_unref(formatCurrency)(totalCaseCosts.value)) + ") will be deducted from the client's share. ", 1)
                                    ], 64))
                              ], 64))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                (__props.feeMethod === _unref(FEE_METHOD).NET)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      (hasConfirmedActiveInterest.value)
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                            _cache[40] || (_cache[40] = _createElementVNode("strong", null, "Net method:", -1)),
                                            _createTextVNode(" These costs (" + _toDisplayString(_unref(formatCurrency)(__props.totalExpenses)) + ") plus confirmed interest (" + _toDisplayString(_unref(formatCurrency)(__props.confirmedTotalInterest)) + ") will be deducted from the recovery amount ", 1),
                                            _cache[41] || (_cache[41] = _createElementVNode("em", null, "before", -1)),
                                            _cache[42] || (_cache[42] = _createTextVNode(" calculating the attorney fee. ", -1))
                                          ], 64))
                                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                            _cache[43] || (_cache[43] = _createElementVNode("strong", null, "Net method:", -1)),
                                            _createTextVNode(" These costs (" + _toDisplayString(_unref(formatCurrency)(__props.totalExpenses)) + ") will be deducted from the recovery amount ", 1),
                                            _cache[44] || (_cache[44] = _createElementVNode("em", null, "before", -1)),
                                            _cache[45] || (_cache[45] = _createTextVNode(" calculating the attorney fee. ", -1))
                                          ], 64))
                                    ], 64))
                                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                      (hasConfirmedActiveInterest.value)
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                            _cache[46] || (_cache[46] = _createElementVNode("strong", null, "Gross method:", -1)),
                                            _createTextVNode(" The attorney fee will be calculated on the full recovery amount. These costs (" + _toDisplayString(_unref(formatCurrency)(__props.totalExpenses)) + ") plus confirmed interest (" + _toDisplayString(_unref(formatCurrency)(__props.confirmedTotalInterest)) + ") will then be deducted from the client's remaining share. ", 1)
                                          ], 64))
                                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                            _cache[47] || (_cache[47] = _createElementVNode("strong", null, "Gross method:", -1)),
                                            _createTextVNode(" The attorney fee will be calculated on the full recovery amount. These costs (" + _toDisplayString(_unref(formatCurrency)(__props.totalExpenses)) + ") will then be deducted from the client's remaining share. ", 1)
                                          ], 64))
                                    ], 64))
                              ], 64))
                      ]),
                      _createElementVNode("div", _hoisted_47, [
                        _createElementVNode("a", {
                          class: "text-primary cursor-pointer",
                          href: "#",
                          onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.$emit('view-expenses')), ["prevent"]))
                        }, " Edit expenses on the Expenses page "),
                        _cache[48] || (_cache[48] = _createTextVNode(", then return here to re-confirm. ", -1))
                      ])
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createElementVNode("div", _hoisted_48, [
                        _createElementVNode("div", _hoisted_49, [
                          _createElementVNode("div", {
                            class: "d-flex align-center gap-3 cursor-pointer flex-grow-1",
                            onClick: _cache[6] || (_cache[6] = ($event: any) => (expenseListOpen.value = !expenseListOpen.value))
                          }, [
                            _createVNode(_component_v_icon, {
                              size: "18",
                              class: _normalizeClass(["expense-list-chevron", { 'expense-list-chevron--open': expenseListOpen.value }])
                            }, {
                              default: _withCtx(() => [...(_cache[49] || (_cache[49] = [
                                _createTextVNode(" mdi-chevron-right ", -1)
                              ]))]),
                              _: 1
                            }, 8, ["class"]),
                            _createElementVNode("span", _hoisted_50, [
                              _createTextVNode(_toDisplayString(__props.firmName ? `${__props.firmName}'s expenses:` : 'Total Expenses:') + " " + _toDisplayString(_unref(formatCurrency)(isClientPaysArrangement.value ? totalCaseCosts.value : __props.totalExpenses)) + " ", 1),
                              _createElementVNode("span", _hoisted_51, " (" + _toDisplayString(tableExpenses.value.length) + ") ", 1),
                              (showInterest.value && __props.totalInterest > 0)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_52, " · Total Interest: " + _toDisplayString(_unref(formatCurrency)(__props.totalInterest)), 1))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          (tableExpenses.value.length > 0)
                            ? (_openBlock(), _createBlock(LlSecondaryButton, {
                                key: 0,
                                size: "small",
                                onClick: _withModifiers(exportExpensesCsv, ["stop"])
                              }, {
                                default: _withCtx(() => [
                                  _cache[51] || (_cache[51] = _createTextVNode(" Export ", -1)),
                                  _createVNode(_component_v_icon, {
                                    size: "18",
                                    class: "ml-1"
                                  }, {
                                    default: _withCtx(() => [...(_cache[50] || (_cache[50] = [
                                      _createTextVNode("mdi-tray-arrow-down", -1)
                                    ]))]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _withDirectives(_createElementVNode("div", null, [
                          (tableExpenses.value.length === 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                                _cache[52] || (_cache[52] = _createTextVNode(" No expenses on this matter. ", -1)),
                                (__props.expenseInlineEnabled)
                                  ? (_openBlock(), _createElementBlock("a", {
                                      key: 0,
                                      class: "text-primary cursor-pointer ml-1",
                                      href: "#",
                                      onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.$emit('open-add-expense')), ["stop","prevent"]))
                                    }, " Add one now. "))
                                  : _createCommentVNode("", true)
                              ]))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createVNode(_component_v_table, {
                                  density: "compact",
                                  class: "expense-list-table"
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("thead", null, [
                                      _createElementVNode("tr", null, [
                                        _cache[56] || (_cache[56] = _createElementVNode("th", { style: {"width":"28px"} }, null, -1)),
                                        _createElementVNode("th", {
                                          class: "text-uppercase text-caption expense-col-sortable",
                                          onClick: _cache[8] || (_cache[8] = ($event: any) => (toggleSort('date')))
                                        }, [
                                          _cache[53] || (_cache[53] = _createTextVNode(" Date ", -1)),
                                          _createVNode(_component_v_icon, {
                                            size: "12",
                                            class: _normalizeClass(["expense-sort-icon", { 'expense-sort-icon--active': sortKey.value === 'date' }])
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(sortKey.value === 'date' && sortDir.value === 'desc' ? 'mdi-arrow-down' : 'mdi-arrow-up'), 1)
                                            ]),
                                            _: 1
                                          }, 8, ["class"])
                                        ]),
                                        _createElementVNode("th", {
                                          class: "text-uppercase text-caption expense-col-sortable",
                                          onClick: _cache[9] || (_cache[9] = ($event: any) => (toggleSort('description')))
                                        }, [
                                          _cache[54] || (_cache[54] = _createTextVNode(" Description ", -1)),
                                          _createVNode(_component_v_icon, {
                                            size: "12",
                                            class: _normalizeClass(["expense-sort-icon", { 'expense-sort-icon--active': sortKey.value === 'description' }])
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(sortKey.value === 'description' && sortDir.value === 'desc' ? 'mdi-arrow-down' : 'mdi-arrow-up'), 1)
                                            ]),
                                            _: 1
                                          }, 8, ["class"])
                                        ]),
                                        (__props.showVendor)
                                          ? (_openBlock(), _createElementBlock("th", _hoisted_54, "Vendor"))
                                          : _createCommentVNode("", true),
                                        (isClientPaysArrangement.value)
                                          ? (_openBlock(), _createElementBlock("th", _hoisted_55, "Status"))
                                          : _createCommentVNode("", true),
                                        _createElementVNode("th", {
                                          class: "text-uppercase text-caption text-right expense-col-sortable",
                                          onClick: _cache[10] || (_cache[10] = ($event: any) => (toggleSort('amount')))
                                        }, [
                                          _cache[55] || (_cache[55] = _createTextVNode(" Amount ", -1)),
                                          _createVNode(_component_v_icon, {
                                            size: "12",
                                            class: _normalizeClass(["expense-sort-icon", { 'expense-sort-icon--active': sortKey.value === 'amount' }])
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(sortKey.value === 'amount' && sortDir.value === 'desc' ? 'mdi-arrow-down' : 'mdi-arrow-up'), 1)
                                            ]),
                                            _: 1
                                          }, 8, ["class"])
                                        ]),
                                        (showInterest.value)
                                          ? (_openBlock(), _createElementBlock("th", _hoisted_56, "Interest"))
                                          : _createCommentVNode("", true)
                                      ])
                                    ]),
                                    _createElementVNode("tbody", null, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paginatedExpenses.value, (expense) => {
                                        return (_openBlock(), _createElementBlock("tr", {
                                          key: expense.id,
                                          class: _normalizeClass({ 'expense-row--clickable': __props.expenseInlineEnabled }),
                                          title: __props.expenseInlineEnabled ? 'Click to edit this expense' : undefined,
                                          onClick: ($event: any) => (__props.expenseInlineEnabled && _ctx.$emit('open-edit-expense', expense.id))
                                        }, [
                                          _createElementVNode("td", _hoisted_58, [
                                            (expense.accounting)
                                              ? (_openBlock(), _createBlock(QboIcon, {
                                                  key: 0,
                                                  size: 14,
                                                  title: "Synced from QuickBooks"
                                                }))
                                              : _createCommentVNode("", true)
                                          ]),
                                          _createElementVNode("td", _hoisted_59, _toDisplayString(expense.date ? _unref(formatLongDateString)(expense.date) : '—'), 1),
                                          _createElementVNode("td", _hoisted_60, _toDisplayString(expense.description || '—'), 1),
                                          (__props.showVendor)
                                            ? (_openBlock(), _createElementBlock("td", _hoisted_61, _toDisplayString(expense.vendor?.displayName || expense.vendor?.name || '—'), 1))
                                            : _createCommentVNode("", true),
                                          (isClientPaysArrangement.value)
                                            ? (_openBlock(), _createElementBlock("td", _hoisted_62, [
                                                _createVNode(_component_v_chip, {
                                                  size: "x-small",
                                                  color: expense.billed ? 'grey' : 'success',
                                                  variant: "tonal"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(expense.billed ? 'Billed' : 'Unbilled'), 1)
                                                  ]),
                                                  _: 2
                                                }, 1032, ["color"])
                                              ]))
                                            : _createCommentVNode("", true),
                                          _createElementVNode("td", _hoisted_63, _toDisplayString(_unref(formatCurrency)(expense.amount)), 1),
                                          (showInterest.value)
                                            ? (_openBlock(), _createElementBlock("td", _hoisted_64, [
                                                (!expense.date)
                                                  ? (_openBlock(), _createElementBlock("span", _hoisted_65, "N/A"))
                                                  : (!__props.expenseFromDate)
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_66, "—"))
                                                    : (_openBlock(), _createElementBlock("span", _hoisted_67, _toDisplayString(_unref(formatCurrency)(interestForExpense(expense))), 1))
                                              ]))
                                            : _createCommentVNode("", true)
                                        ], 10, _hoisted_57))
                                      }), 128))
                                    ])
                                  ]),
                                  _: 1
                                }),
                                _createElementVNode("div", _hoisted_68, [
                                  _createElementVNode("span", null, "Showing " + _toDisplayString(paginationStart.value) + "–" + _toDisplayString(paginationEnd.value) + " of " + _toDisplayString(tableExpenses.value.length), 1),
                                  (totalPages.value > 1)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_69, [
                                        _createVNode(LlSecondaryButton, {
                                          icon: "mdi-chevron-left",
                                          variant: "text",
                                          size: "x-small",
                                          "aria-label": "Previous page",
                                          disabled: currentPage.value <= 1,
                                          onClick: _cache[11] || (_cache[11] = ($event: any) => (currentPage.value--))
                                        }, null, 8, ["disabled"]),
                                        _createElementVNode("span", _hoisted_70, _toDisplayString(currentPage.value) + " / " + _toDisplayString(totalPages.value), 1),
                                        _createVNode(LlSecondaryButton, {
                                          icon: "mdi-chevron-right",
                                          variant: "text",
                                          size: "x-small",
                                          "aria-label": "Next page",
                                          disabled: currentPage.value >= totalPages.value,
                                          onClick: _cache[12] || (_cache[12] = ($event: any) => (currentPage.value++))
                                        }, null, 8, ["disabled"])
                                      ]))
                                    : _createCommentVNode("", true)
                                ])
                              ], 64)),
                          _createElementVNode("div", _hoisted_71, [
                            _createElementVNode("div", {
                              class: _normalizeClass(["expense-totals-row", { 'expense-totals-row--total': isClientPaysArrangement.value }])
                            }, [
                              _createElementVNode("span", {
                                class: _normalizeClass(isClientPaysArrangement.value ? 'text-body-1 font-weight-bold' : 'text-body-2')
                              }, _toDisplayString(isClientPaysArrangement.value ? 'Total Case Costs' : 'Total Expenses'), 3),
                              _createElementVNode("span", {
                                class: _normalizeClass(isClientPaysArrangement.value ? 'text-body-1 font-weight-bold text-green-darken-2' : 'text-body-2')
                              }, _toDisplayString(_unref(formatCurrency)(isClientPaysArrangement.value ? totalCaseCosts.value : __props.totalExpenses)), 3)
                            ], 2),
                            (isClientPaysArrangement.value && __props.billedExpensesTotal > 0)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createElementVNode("div", _hoisted_72, [
                                    _cache[57] || (_cache[57] = _createElementVNode("span", { class: "text-body-2" }, "Unbilled (confirming now)", -1)),
                                    _createElementVNode("span", _hoisted_73, _toDisplayString(_unref(formatCurrency)(__props.totalExpenses)), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_74, [
                                    _cache[58] || (_cache[58] = _createElementVNode("span", { class: "text-body-2" }, "Previously billed", -1)),
                                    _createElementVNode("span", _hoisted_75, _toDisplayString(_unref(formatCurrency)(__props.billedExpensesTotal)), 1)
                                  ])
                                ], 64))
                              : _createCommentVNode("", true),
                            (showInterest.value && __props.expenseFromDate && __props.interestConfirmed && !interestNeedsReconfirm.value)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _createElementVNode("div", _hoisted_76, [
                                    _createElementVNode("span", _hoisted_77, " Total Expense Interest (" + _toDisplayString(__props.companyExpenseInterestRate) + "% through " + _toDisplayString(expenseFromDateDisplay.value) + ") ", 1),
                                    _createElementVNode("span", _hoisted_78, _toDisplayString(_unref(formatCurrency)(__props.totalInterest)), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_79, [
                                    _cache[59] || (_cache[59] = _createElementVNode("span", { class: "text-body-1 font-weight-bold" }, "Total with Interest", -1)),
                                    _createElementVNode("span", _hoisted_80, _toDisplayString(_unref(formatCurrency)(__props.totalExpenses + __props.totalInterest)), 1)
                                  ])
                                ], 64))
                              : _createCommentVNode("", true)
                          ])
                        ], 512), [
                          [_vShow, expenseListOpen.value]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_81, [
                        (__props.expenseArrangement === _unref(EXPENSE_ARRANGEMENT).ABSORBED)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              (__props.feeMethod === _unref(FEE_METHOD).NET)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _cache[60] || (_cache[60] = _createElementVNode("strong", null, "Firm absorbs expenses (net):", -1)),
                                    _createTextVNode(" These costs (" + _toDisplayString(_unref(formatCurrency)(__props.totalExpenses)) + ") will reduce the fee base — the attorney fee is calculated on the settlement minus expenses. The client pays no expenses. ", 1)
                                  ], 64))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _cache[61] || (_cache[61] = _createElementVNode("strong", null, "Firm absorbs expenses (gross):", -1)),
                                    _createTextVNode(" These costs (" + _toDisplayString(_unref(formatCurrency)(__props.totalExpenses)) + ") will be deducted from the gross attorney fee. The client pays no expenses. ", 1)
                                  ], 64))
                            ], 64))
                          : (__props.expenseArrangement === _unref(EXPENSE_ARRANGEMENT).CLIENT)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                (__props.feeMethod === _unref(FEE_METHOD).NET)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      _cache[62] || (_cache[62] = _createElementVNode("strong", null, "Net method:", -1)),
                                      _createTextVNode(" All case costs (" + _toDisplayString(_unref(formatCurrency)(totalCaseCosts.value)) + ") are deducted from the recovery ", 1),
                                      _cache[63] || (_cache[63] = _createElementVNode("em", null, "before", -1)),
                                      _cache[64] || (_cache[64] = _createTextVNode(" calculating the fee. ", -1))
                                    ], 64))
                                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                      _cache[65] || (_cache[65] = _createElementVNode("strong", null, "Gross method:", -1)),
                                      _createTextVNode(" The attorney fee is calculated on the full recovery amount. Case costs (" + _toDisplayString(_unref(formatCurrency)(totalCaseCosts.value)) + ") will be deducted from the client's share. ", 1)
                                    ], 64))
                              ], 64))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                (__props.feeMethod === _unref(FEE_METHOD).NET)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      (hasConfirmedActiveInterest.value)
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                            _cache[66] || (_cache[66] = _createElementVNode("strong", null, "Net method:", -1)),
                                            _createTextVNode(" These costs (" + _toDisplayString(_unref(formatCurrency)(__props.totalExpenses)) + ") plus confirmed interest (" + _toDisplayString(_unref(formatCurrency)(__props.confirmedTotalInterest)) + ") will be deducted from the recovery amount ", 1),
                                            _cache[67] || (_cache[67] = _createElementVNode("em", null, "before", -1)),
                                            _cache[68] || (_cache[68] = _createTextVNode(" calculating the attorney fee. ", -1))
                                          ], 64))
                                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                            _cache[69] || (_cache[69] = _createElementVNode("strong", null, "Net method:", -1)),
                                            _createTextVNode(" These costs (" + _toDisplayString(_unref(formatCurrency)(__props.totalExpenses)) + ") will be deducted from the recovery amount ", 1),
                                            _cache[70] || (_cache[70] = _createElementVNode("em", null, "before", -1)),
                                            _cache[71] || (_cache[71] = _createTextVNode(" calculating the attorney fee. ", -1))
                                          ], 64))
                                    ], 64))
                                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                      (hasConfirmedActiveInterest.value)
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                            _cache[72] || (_cache[72] = _createElementVNode("strong", null, "Gross method:", -1)),
                                            _createTextVNode(" The attorney fee will be calculated on the full recovery amount. These costs (" + _toDisplayString(_unref(formatCurrency)(__props.totalExpenses)) + ") plus confirmed interest (" + _toDisplayString(_unref(formatCurrency)(__props.confirmedTotalInterest)) + ") will then be deducted from the client's remaining share. ", 1)
                                          ], 64))
                                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                            _cache[73] || (_cache[73] = _createElementVNode("strong", null, "Gross method:", -1)),
                                            _createTextVNode(" The attorney fee will be calculated on the full recovery amount. These costs (" + _toDisplayString(_unref(formatCurrency)(__props.totalExpenses)) + ") will then be deducted from the client's remaining share. ", 1)
                                          ], 64))
                                    ], 64))
                              ], 64))
                      ]),
                      (showInterest.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_82, [
                            _createElementVNode("div", {
                              class: "d-flex align-center gap-2 cursor-pointer mb-0",
                              onClick: _cache[13] || (_cache[13] = ($event: any) => (interestOpen.value = !interestOpen.value))
                            }, [
                              _createVNode(_component_v_icon, {
                                size: "16",
                                class: _normalizeClass(["expense-list-chevron", { 'expense-list-chevron--open': interestOpen.value }])
                              }, {
                                default: _withCtx(() => [...(_cache[74] || (_cache[74] = [
                                  _createTextVNode(" mdi-chevron-right ", -1)
                                ]))]),
                                _: 1
                              }, 8, ["class"]),
                              _createElementVNode("span", _hoisted_83, " Expense Interest (" + _toDisplayString(__props.companyExpenseInterestRate) + "%) ", 1),
                              (hasConfirmedActiveInterest.value)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_84, [
                                    _createVNode(LlIcon, {
                                      icon: "mdi-check-circle",
                                      size: "14",
                                      color: "success"
                                    }),
                                    _cache[75] || (_cache[75] = _createElementVNode("span", { class: "text-caption text-green-darken-2 ml-1" }, "Confirmed", -1))
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _withDirectives(_createElementVNode("div", _hoisted_85, [
                              (!__props.expenseFromDate)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_86, [
                                    _createVNode(_component_v_icon, {
                                      size: "14",
                                      color: "grey"
                                    }, {
                                      default: _withCtx(() => [...(_cache[76] || (_cache[76] = [
                                        _createTextVNode("mdi-information-outline", -1)
                                      ]))]),
                                      _: 1
                                    }),
                                    _cache[77] || (_cache[77] = _createTextVNode(" Set the Interest As-Of Date in ", -1)),
                                    _cache[78] || (_cache[78] = _createElementVNode("strong", null, "Settings", -1)),
                                    _cache[79] || (_cache[79] = _createTextVNode(" to calculate interest. ", -1))
                                  ]))
                                : _createCommentVNode("", true),
                              (noDateCount.value > 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_87, _toDisplayString(noDateCount.value) + " expense" + _toDisplayString(noDateCount.value > 1 ? 's' : '') + " excluded from interest calculation (no date) ", 1))
                                : _createCommentVNode("", true),
                              (afterAsOfCount.value > 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_88, _toDisplayString(afterAsOfCount.value) + " expense" + _toDisplayString(afterAsOfCount.value > 1 ? 's' : '') + " dated after the as-of date accrue 0 interest ", 1))
                                : _createCommentVNode("", true),
                              (hasConfirmedActiveInterest.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_89, [
                                    _createElementVNode("div", _hoisted_90, [
                                      _createElementVNode("div", _hoisted_91, [
                                        _createVNode(LlIcon, {
                                          icon: "mdi-check-circle",
                                          color: "success",
                                          size: "18"
                                        }),
                                        _createElementVNode("div", null, [
                                          _cache[80] || (_cache[80] = _createElementVNode("div", { class: "text-body-2 font-weight-bold text-green-darken-2" }, " Interest Confirmed — Expense Created ", -1)),
                                          _createElementVNode("div", _hoisted_92, _toDisplayString(__props.companyExpenseInterestRate) + "% interest charged on advanced client costs ", 1)
                                        ])
                                      ]),
                                      _createElementVNode("span", _hoisted_93, _toDisplayString(_unref(formatCurrency)(__props.confirmedTotalInterest)), 1)
                                    ]),
                                    _createElementVNode("a", {
                                      class: "text-body-2 text-error cursor-pointer",
                                      href: "#",
                                      onClick: _cache[14] || (_cache[14] = _withModifiers(($event: any) => (_ctx.$emit('remove-interest')), ["prevent"]))
                                    }, " Remove interest expense ")
                                  ]))
                                : _createCommentVNode("", true),
                              (interestNeedsReconfirm.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_94, [
                                    _createElementVNode("div", _hoisted_95, [
                                      _createElementVNode("span", _hoisted_96, [
                                        _createTextVNode(" Total Expense Interest (" + _toDisplayString(__props.companyExpenseInterestRate) + "%): ", 1),
                                        _createVNode(LlTooltip, { text: "Ensure your fee agreement authorizes interest on advanced expenses before including this line item." }, {
                                          activator: _withCtx(() => [
                                            _createVNode(_component_v_icon, {
                                              size: "14",
                                              color: "grey",
                                              class: "cursor-pointer"
                                            }, {
                                              default: _withCtx(() => [...(_cache[81] || (_cache[81] = [
                                                _createTextVNode("mdi-information-outline", -1)
                                              ]))]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _createElementVNode("span", _hoisted_97, _toDisplayString(_unref(formatCurrency)(__props.totalInterest)), 1)
                                    ]),
                                    _createVNode(LlSecondaryButton, {
                                      color: "primary",
                                      disabled: !__props.expenseFromDate || __props.totalInterest <= 0 || __props.saving,
                                      loading: __props.saving,
                                      class: "mb-1",
                                      onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.$emit('confirm-interest')))
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(__props.interestConfirmed ? `Interest Confirmed (${_unref(formatCurrency)(__props.totalInterest)})` : `Confirm Interest (${_unref(formatCurrency)(__props.totalInterest)})`), 1)
                                      ]),
                                      _: 1
                                    }, 8, ["disabled", "loading"]),
                                    _createElementVNode("div", _hoisted_98, " Confirming creates an expense: \"" + _toDisplayString(__props.companyExpenseInterestRate) + "% interest charged on advanced client costs\" ", 1)
                                  ]))
                                : _createCommentVNode("", true)
                            ], 512), [
                              [_vShow, interestOpen.value]
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (showCoCounselSection.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_99, [
                            _createElementVNode("div", _hoisted_100, [
                              (!coCounselSectionOpen.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_101, [
                                    _createVNode(LlSecondaryButton, {
                                      variant: "text",
                                      color: "primary",
                                      size: "small",
                                      class: "co-counsel-toggle-link text-body-2 px-0",
                                      onClick: _cache[16] || (_cache[16] = ($event: any) => (coCounselSectionOpen.value = true))
                                    }, {
                                      default: _withCtx(() => [...(_cache[82] || (_cache[82] = [
                                        _createTextVNode(" Need to add co-counsel expenses? ", -1)
                                      ]))]),
                                      _: 1
                                    })
                                  ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_102, [
                                    _createElementVNode("div", _hoisted_103, [
                                      _cache[84] || (_cache[84] = _createElementVNode("span", { class: "text-body-2 font-weight-bold text-green-darken-4" }, "Co-Counsel / Referral Expenses", -1)),
                                      _createVNode(LlSecondaryButton, {
                                        variant: "text",
                                        color: "primary",
                                        size: "small",
                                        class: "co-counsel-toggle-link text-body-2 px-0",
                                        onClick: _cache[17] || (_cache[17] = ($event: any) => (coCounselSectionOpen.value = false))
                                      }, {
                                        default: _withCtx(() => [...(_cache[83] || (_cache[83] = [
                                          _createTextVNode(" Hide ", -1)
                                        ]))]),
                                        _: 1
                                      })
                                    ]),
                                    (isFirmAbsorbsArrangement.value)
                                      ? (_openBlock(), _createBlock(LlWarningBanner, {
                                          key: 0,
                                          visible: true
                                        }, {
                                          default: _withCtx(() => [...(_cache[85] || (_cache[85] = [
                                            _createTextVNode(" Co-Counsel expenses are absorbed by the generating firm and are not itemized separately or shown on the settlement statement. ", -1)
                                          ]))]),
                                          _: 1
                                        }))
                                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.coCounselExpenses, (row) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                              key: row.id,
                                              class: "co-counsel-row d-flex align-center justify-space-between py-1",
                                              "data-vendor-id": row.vendorId
                                            }, [
                                              _createElementVNode("div", null, [
                                                _createElementVNode("span", _hoisted_105, _toDisplayString(row.vendorDisplayName), 1),
                                                _createElementVNode("span", _hoisted_106, _toDisplayString(_unref(roleLabel)(row.role)), 1)
                                              ]),
                                              _createElementVNode("div", _hoisted_107, [
                                                (row.role === 'coCounsel')
                                                  ? (_openBlock(), _createElementBlock("span", _hoisted_108, "Expenses ($):"))
                                                  : _createCommentVNode("", true),
                                                _createElementVNode("div", _hoisted_109, [
                                                  (row.role === 'coCounsel')
                                                    ? (_openBlock(), _createBlock(LlTextField, {
                                                        key: 0,
                                                        "model-value": row.amount,
                                                        type: "number",
                                                        density: "compact",
                                                        "hide-details": "",
                                                        step: "0.01",
                                                        "onUpdate:modelValue": (value) => onCoCounselAmountChange(row.vendorId, value)
                                                      }, null, 8, ["model-value", "onUpdate:modelValue"]))
                                                    : (_openBlock(), _createElementBlock("span", _hoisted_110, "$0"))
                                                ])
                                              ])
                                            ], 8, _hoisted_104))
                                          }), 128)),
                                          _createElementVNode("div", _hoisted_111, [
                                            _cache[86] || (_cache[86] = _createElementVNode("span", { class: "text-body-2 font-weight-bold text-green-darken-4" }, "Co-Counsel Expense Total:", -1)),
                                            _createElementVNode("span", _hoisted_112, _toDisplayString(_unref(formatCurrency)(coCounselExpenseTotal.value)), 1)
                                          ])
                                        ], 64))
                                  ]))
                            ]),
                            _createElementVNode("div", _hoisted_113, [
                              _cache[87] || (_cache[87] = _createElementVNode("span", { class: "text-body-1 font-weight-bold" }, "Total Expenses:", -1)),
                              _createElementVNode("span", _hoisted_114, _toDisplayString(_unref(formatCurrency)(totalExpensesWithCoCounsel.value)), 1)
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ], 64)),
                (__props.hasNegativeFeeBase)
                  ? (_openBlock(), _createBlock(AlertBar, {
                      key: 2,
                      type: "error",
                      class: "mb-4"
                    }, {
                      default: _withCtx(() => [
                        _cache[88] || (_cache[88] = _createElementVNode("div", { class: "font-weight-bold mb-1" }, "Expenses exceed recovery", -1)),
                        _createElementVNode("div", _hoisted_115, " With the \"Net of Expenses\" fee method, included expenses (" + _toDisplayString(_unref(formatCurrency)(__props.totalExpenses)) + ") exceed the recovery amount. You cannot proceed until expenses are reduced or the fee method is changed to \"Gross.\" ", 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ], 64)),
          _createElementVNode("div", _hoisted_116, [
            _createVNode(LlSecondaryButton, {
              onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.$emit('go-back')))
            }, {
              default: _withCtx(() => [...(_cache[89] || (_cache[89] = [
                _createTextVNode(" ← Back ", -1)
              ]))]),
              _: 1
            }),
            _createVNode(LlSecondaryButton, {
              color: "primary",
              style: {"margin-left":"auto"},
              disabled: __props.hasNegativeFeeBase || __props.loading || (showInterest.value && __props.totalInterest > 0 && interestNeedsReconfirm.value),
              loading: __props.saving,
              onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.$emit('confirm-expenses')))
            }, {
              default: _withCtx(() => [
                (__props.redesignEnabled)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode("Confirm Expenses →")
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode("Confirm Expenses (" + _toDisplayString(confirmButtonLabel.value) + ") →", 1)
                    ], 64))
              ]),
              _: 1
            }, 8, ["disabled", "loading"])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})